function RichardsonSkin() {
}

RichardsonSkin.init = function() {
    ub.current_modifier = 1;
    $("div#left-side-toolbar").html("")
    // Show Uniform name and 
    if (typeof ub.config.order_editor_configuration === "undefined") {
        $("div.customizer-uniform-information").html("");
    } else {
        $(".debug-panel").addClass("uk-hidden");
    }

    $("p.verbiage-text").addClass('cp-fc-black');
    
    RichardsonSkin.funcs.setupSkin(0xffffff);
}

RichardsonSkin.events = {
    isInit: true,
    reInitEvents: true,

    init: function() {
        var _this = this;
        if (RichardsonSkin.events.isInit) {
            $("div#left-side-toolbar").on('click', '.change-perspective-button', _this.onClickPerspectiveThumbnail);
            $("#right-pane-column .richardson-footer").on('click', '.richardson-onNext', _this.onNextPanel);
            $("#right-pane-column .richardson-footer").on('click', '.richardson-onPrevious', _this.onPreviousPanel);
            $(".richardson-header").on('click', '.change-fabric', _this.onChangeFabric);
            $(".richardson-header").on("click", ".select-new-style", _this.onLoadSelectNewStyle);

            if (ub.page === "saved-design") {
                $("#left-pane-column").on('click', '#top-left-side-toolbar .customize-uniform', _this.onCustomize);
            }

            $(window).resize(function() {
                RichardsonSkin.funcs.changeIframeHeightPostMessage();
            });

            RichardsonSkin.events.isInit = false;
        }

        RosterPanel.events.init();
        
        if (!ub.config.isMagentoVersionTwo) {
            if (typeof window.userData !== "undefined" && window.userData === "object") {
                ub.user = window.userData;
            }
        }

        if (ub.user) {
            RichardsonSaveDesign.events.init();
        }
    },

    reInitNextAndPrev: function() {
        var self = this;
        if (RichardsonSkin.events.reInitEvents) {
            $("#right-pane-column .richardson-footer").on('click', '.richardson-onNext', self.onNextPanel);
            $("#right-pane-column .richardson-footer").on('click', '.richardson-onPrevious', self.onPreviousPanel);
            RichardsonSkin.events.reInitEvents = false;
        }
    },

    onNextPanel: function() {
        var current_modifier = ub.current_modifier;
        var total_modifier = $("#property-modifiers-menu .menu-item").length;

        if (ub.current_modifier !== total_modifier) {
            if (current_modifier >= 1) {
                ub.current_modifier++;
                $('#property-modifiers-menu .menu-item[data-modifier-number="'  + ub.current_modifier +'"]').trigger('click');
            }
        }
    },

    onPreviousPanel: function() {
        var current_modifier = ub.current_modifier;
        var modifier_limit = 1;

        if (ub.current_modifier !== modifier_limit) {
            ub.current_modifier--
            $('#property-modifiers-menu .menu-item[data-modifier-number="'  + ub.current_modifier +'"]').trigger('click');
        }
    },

    onChangeFabric: function() {
        if (!$('#property-modifiers-menu .menu-item-fabrics').hasClass('active')) {
            $('#property-modifiers-menu .menu-item-fabrics').trigger("click");
        }
    },

    onLoadSelectNewStyle: function() {
        RichardsonSelectNewStyle.funcs.init();
    },

    onClickPerspectiveThumbnail: function(e) {
        $(".perspective-container a.active").removeClass('active');
        $(this).closest(".perspective-container .perspective").find("a").addClass("active")
        /* Act on the event */
        var view = $(this).data('perspective');
        if (ub.active_view !== view) {
            var perspective = new PerspectiveController();
            perspective.setPerspective(view)
        }

        // Generate Thumbnail
        if (e.altKey) {
            RichardsonSkin.funcs.generateThumbnail(ub.active_view);
        }
    },

    onCustomize: function() {
        $("#left-pane-column #top-left-side-toolbar .customize-uniform").hide();
        ub.funcs.restoreUI()
    }
}

RichardsonSkin.funcs = {
    setupSkin: function(color) {
        this.enableRichardsonNavigator();
        this.removeSpecialModifier()
        this.setupRightPanelHeader();
        this.removeNavigationHeader();
        this.changeIframeHeightPostMessage();

        
        this.changeStageBackgroundColor(color);
        this.setupSidePanelToolbar();
        this.setupFooter();

        // Bind events
        RichardsonSkin.events.init();

        if (typeof ub.config.order_editor_configuration !== "undefined") {
            if (typeof ub.config.order_status !== "undefined" || ub.config.order_status !== "completed") {
                RichardsonOrderEditor.events.init();
            }
        } else {
            DesignPreview.events.init();
        }

        RichardsonLogin.events.init();

        // Inksoft Application Error Checker
        if (typeof ub.config.savedDesignInfo === "object" && ub.page === "saved-design") {
            Inksoft.funcs.applicationErrorChecker();
        }
    },

    setupFooter: function() {
        $("div#right-main-window.pane-main-window.footer_buttons_container").remove();

        var data = {
            isLoggedIn: ub.funcs.isLoggedIn(),
            isDealer: ub.funcs.isDealer(),
            isPlayer: ub.funcs.isPlayer(),
            user: ub.user
        };

        var richardson_footer = document.getElementById("m-richardson-footer");
        var render_footer = Mustache.render(richardson_footer.innerHTML, {userData: data});
        if ($("#right-pane-column .richardson-footer").length !== 0) {
            $("#right-pane-column .richardson-footer").remove();
        }
        
        $("div#right-pane-column").append(render_footer);
        $(".richardson-footer .richardson-onPrevious").css('pointer-events', 'none');

        // For viewing only.
        if (typeof ub.config.savedDesignInfo === "object" && typeof ub.config.order_editor_configuration === "undefined") {
            if (ub.user) {
                if (ub.user.type === "administrator" || ub.user.type === "normal") {
                    $("#right-pane-column .uniform-summary-preview").addClass("uk-hidden");
                }
            }
        }

        // For Completed Orders
        RichardsonOrderEditor.statusChecker(function() {
            $("#right-pane-column .uniform-summary-preview").addClass("uk-hidden");
            $("#right-pane-column .manage-team-roster").html("");
            $("#right-pane-column .manage-team-roster").html("View Roster & App Size");
        });
    },

    enableRichardsonNavigator: function() {
        $("div.richardson-footer .richardson-onPrevious").css('pointer-events', 'auto');
        $(".richardson-footer .richardson-onNext").css('pointer-events', 'auto');
    },

    richardsonPTSCategory: function() {
        var category;
        var blockPattern = ub.current_material.material.block_pattern;

        if (blockPattern.includes("PTS Signature")) {
            category = "PTS 90";
        } else if (blockPattern.includes("PTS Pro Select")) {
            category = "PTS 80";
        } else if (blockPattern.includes("PTS Select")) {
            category = "PTS 70";
        } else if (blockPattern.includes("PTS Hoodie")) {
            category = "PTS 10";
        } else if (blockPattern.includes("PTS Cage Jacket")) {
            category = "PTS 20";
        }

        return category;
    },

    perspectiveThumbnailAutoUpdate: function() {
        ub.front_view.visible = true;
        ub.back_view.visible = true;
        ub.left_view.visible = true;
        ub.right_view.visible = true;
        var material = ub.current_material.material;

        if (typeof ub.data.refreshThumbnail !== "undefined" && ub.data.refreshThumbnail) {
            ub.data.refreshThumbnail = false;
            return;
        }

        if (typeof ub.data.activatedApplication !== "undefined") {
            // Hide Application Tool
            ub.funcs.hideApplicationTools(ub.data.activatedApplication);
        }

        var front, back, left, right;
        if (ub.page === "saved-design") {
            var save_thumbnail = ub.current_material.settings.thumbnails;
            // Change Asset URL
            _.map(save_thumbnail, function(item) {
                item = ub.utilities.changeAssetUrl(item);
            });

            if (!_.isEmpty(save_thumbnail.front_view) && !_.isEmpty(save_thumbnail.back_view) && !_.isEmpty(save_thumbnail.left_view) && !_.isEmpty(save_thumbnail.right_view) && ub.data.useThumbnailPath) {
                front = save_thumbnail.front_view;
                back = save_thumbnail.back_view;
                left = save_thumbnail.left_view;
                right = save_thumbnail.right_view;

                ub.data.useThumbnailPath = false;
            } else {
                front = ub.getThumbnailImage("front_view");
                back  = ub.getThumbnailImage("back_view");
                left  = ub.getThumbnailImage("left_view");
                right  = ub.getThumbnailImage("right_view");
            }

        } else {
            // Change Asset URL
            material.thumbnail_path = ub.utilities.changeAssetUrl(material.thumbnail_path);
            material.thumbnail_path_front = ub.utilities.changeAssetUrl(material.thumbnail_path_front);
            material.thumbnail_path_back = ub.utilities.changeAssetUrl(material.thumbnail_path_back);
            material.thumbnail_path_left = ub.utilities.changeAssetUrl(material.thumbnail_path_left);
            material.thumbnail_path_right = ub.utilities.changeAssetUrl(material.thumbnail_path_right);

            if (!_.isEmpty(material.thumbnail_path_front) && !_.isEmpty(material.thumbnail_path_back) && !_.isEmpty(material.thumbnail_path_left) && !_.isEmpty(material.thumbnail_path_right) && ub.data.useThumbnailPath) {
                front = material.thumbnail_path_front;
                back = material.thumbnail_path_back;
                left = material.thumbnail_path_left;
                right = material.thumbnail_path_right;

                ub.data.useThumbnailPath = false;
            } else {
                front = ub.getThumbnailImage("front_view");
                back  = ub.getThumbnailImage("back_view");
                left  = ub.getThumbnailImage("left_view");
                right  = ub.getThumbnailImage("right_view");
            }
        }

        if (typeof ub.data.activatedApplication !== "undefined") {
            // Show Application Tool
            ub.funcs.hideApplicationTools(ub.data.activatedApplication, 1);
        }

        if (Worker) {
            var worker = new Worker('/workers/image-worker.js');
            worker.postMessage([
                {
                    image: front,
                    perspective: "front"
                },
                {
                    image: back,
                    perspective: "back"
                },
                {
                    image: left,
                    perspective: "left"
                },
                {
                    image: right,
                    perspective: "right"
                },
            ]);

            worker.onmessage = function(e) {
                var template = document.getElementById("m-left-panel-toolbar");
                var rendered_template = Mustache.render(template.innerHTML, {perspectives: e.data});
                $("div#left-side-toolbar").html("");
                $("div#left-side-toolbar").html(rendered_template);
                $(".perspective .change-perspective-button[data-perspective='"+ ub.active_view +"']").addClass('active');
                ub.utilities.info("Updating Uniform Thumbnail via worker");
            };
        } else {
            // Setup perspective

            var perspectives = [
               {
                   "perspective": "front",
                   "image": front
               },
               {
                   "perspective": "back",
                   "image": back
               },
               {
                   "perspective": "left",
                   "image": left
               },
               {
                   "perspective": "right",
                   "image": right
               }
            ];

            var template = document.getElementById("m-left-panel-toolbar");
            var rendered_template = Mustache.render(template.innerHTML, {perspectives: perspectives});
            $("div#left-side-toolbar").html("");
            $("div#left-side-toolbar").html(rendered_template);
            $(".perspective .change-perspective-button[data-perspective='"+ ub.active_view +"']").addClass('active');
        }
    },

    removeSpecialModifier: function() {
        $("div#right-main-window.pane-main-window.footer_buttons_container").remove();
        $("#right-main-window.pane-main-window").css('height', '600px');
    },

    setupSidePanelToolbar: function() {
        // Add CSS in left side toolbar
        $("div#left-side-toolbar").css({
            "top": ub.config.isHeaderVisible ? '220px' : "100px",
            "left": '120px'
        });

        $("div#right-pane-column").css({
            "top": ub.config.isHeaderVisible ? '220px' : "60px",
            "right": "100px"
        });

        if (typeof ub.config.order_editor_configuration !== "undefined") {
            $("div#right-pane-column").css({
                "top": "115px",
            });

            $("div#left-side-toolbar").css({
                "top": "175px",
                "left": '150px'
            });
        }
    },

    setupRightPanelHeader: function() {
        $("div.options_panel_header").html("");
        var uniform_name = this.prepareStyleDescription();
        var template = document.getElementById("m-richardson-right-panel-header");
        var data = {
            "uniform_name": uniform_name,
            "block_pattern": ub.current_material.material.model_name,
            "application_type": ub.current_material.material.style_number
        };

        // Setup Config description (For PDF)
        ub.config.description = {
            uniform_name: uniform_name,
            model_name: ub.current_material.material.model_name,
            model_number: ub.current_material.material.style_number,
            blockPattern: ub.config.blockPattern
        }
        
        var rendered = Mustache.render(template.innerHTML, data);
        $("div.options_panel_header").html(rendered);
        if (uniform_name.length > 38) {
            $(".richardson-header .uniform-name").css("font-size", "14px");
        }
    },

    removeNavigationHeader: function() {
        $("nav.navbar.navbar-default.navbar-fixed-top").remove();
    },

    changeStageBackgroundColor: function(color) {
        $("#main_container").css({
            "display": "block",
            "margin": "0"
        });

        if  (typeof color !== "undefined") {
            ub.renderer.backgroundColor = color;
        }
    },

    prepareStyleDescription: function() {
        var uniformaApplicationType = ub.funcs.isSublimated() ? "sublimated" : ub.funcs.isTackleTwill() ? "tackle twill" : ub.funcs.isKnitted() ? "Knit-In"  : "";

        var uniformName = ub.current_material.material.name;
        var styleDescription = "";
        var replaceUniformName = "";

        if (ub.funcs.isTackleTwill() && ub.funcs.isLower() && uniformName.includes("Pant")) {
            uniformaApplicationType = "Color Dyed";
        }

        if (ub.funcs.isTackleTwill() && ub.funcs.is_upper()) {
            uniformaApplicationType = "Hypr Twill";
        }

        if (uniformName.includes("PTS Signature")) {
            replaceUniformName = uniformName.replace("PTS Signature ", "");
        } else if (uniformName.includes("PTS Pro Select")) {
            replaceUniformName = uniformName.replace("PTS Pro Select ", "");
        } else if (uniformName.includes("PTS Select")) {
            replaceUniformName = uniformName.replace("PTS Select ", "");
        } else if (uniformName.includes("PTS Wheelhouse")) {
            replaceUniformName = uniformName.replace("PTS ", "");
        } else if (uniformName.includes("Color Dyed Field Sock") || uniformName.includes("Color Dyed Crew Sock")) {
            replaceUniformName = uniformName.replace("Color Dyed ", "");
        } else if (uniformName.includes("Pro Select")) {
            replaceUniformName = uniformName.replace("Pro Select ", "");
        } else if (uniformName.includes("Color Infused Crew Sock")) {
            replaceUniformName = uniformName.replace("Color Infused ", "");
        } else if (uniformName.includes("PTS Five-Tool")) {
            replaceUniformName = uniformName.replace("PTS ", "");
        }

        styleDescription = uniformaApplicationType + " " + replaceUniformName;
        return styleDescription;
    },

    generateThumbnail: function(view) {
        var image = ub.getThumbnailImage(view + "_view");
        if (Worker) {
            var worker = new Worker('/workers/image-worker.js');
            worker.postMessage([
                {
                    image: image
                }
            ]);

            worker.onmessage = function(e) {
                ub.utilities.info("Generating using worker");
                $("#generateThumbnail div.thumbnail img").attr("src", "");
                $("#generateThumbnail div.thumbnail img").attr("src", e.data[0].image);
                UIkit.modal("#generateThumbnail").show();
            };
        
        } else {
            $("#generateThumbnail div.thumbnail img").attr("src", "");
            $("#generateThumbnail div.thumbnail img").attr("src", image);
            UIkit.modal("#generateThumbnail").show();
        }
    },

    changeIframeHeightPostMessage: function() {
        if (top.location !== window.location) {
            // Change Iframe VH
            ub.utilities.info("Changing Iframe Height");
            
            var size = 120;
            var width = $(window).width();
            if (width >= 2200) {
                size = 90;
            } else if (width >= 1800) {
                size = 100;
            } else if (width >= 1700) {
                size = 110;
            } else if (width >= 1600) {
                size = 115;
            } else if (width >= 1500){
                size = 120;
            } else if (width <= 1500 && width > 1500) {
                size = 130;
            } else if (width <= 1500 && width > 1100) {
                size = 150;
            } else if (width >= 900) {
                size = 200;
            }

            var obj = {
                "action": "update_iframe",
                "size": size
            };

            parent.postMessage(obj, ub.config.magentoURL);
        }
    }
}